import { FC } from 'react';
import { LastChangedEntity } from '../common/components';
import { Entity } from '../common/queryClient';
import { TextLabel } from '../common/components/TextLabel';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './LockData.translations.json';
import { formatTime } from '../common/utils';
import { LockResponse } from './query/useLockQuery';

const { addTranslations, useTranslation } = i18nNsFactory('locked-by');
addTranslations(translations);

export interface LockedByProps {
  entity?: Pick<Entity, 'modifiedAt' | 'modifiedBy'>;
  error: string | null;
  lockData?: LockResponse;
}

export const LockData: FC<LockedByProps> = ({ entity, error, lockData }) => {
  const { t } = useTranslation();

  if (error) {
    return <TextLabel value={error} />;
  }

  if (!lockData?.lock) {
    return <LastChangedEntity entity={entity} />;
  }

  const { lock, owner } = lockData;
  const options: { [key: string]: string | null } = {
    changedBy: lock.username,
    until: formatTime(lock.expiry) ?? null,
  };
  if (owner) {
    options['context'] = 'yourself';
  }
  const value = t('locked-by-user', options);

  return <TextLabel value={value} />;
};
